import { MediaType } from "../../../types";
import { VideoAsset } from "./video";

export class Video360Asset extends VideoAsset {
  getMediaType() {
    return MediaType.Video360;
  }
}
